module.exports = __webpack_public_path__ + "static/img/sketch.94ed2aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discover/sketch.png
// module id = uqZU
// module chunks = 1